import { render, staticRenderFns } from "./sticky-nav.vue?vue&type=template&id=6808b86c&scoped=true&lang=pug&"
var script = {}
import style0 from "./sticky-nav.vue?vue&type=style&index=0&id=6808b86c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808b86c",
  null
  
)

export default component.exports